var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.666902in",
    height: "1.19369in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 183.41 328.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.26 27.29l136.13 137.64 -134.26 135.22c-18.87,19.01 4.41,38.29 20.55,22l155.72 -157.22 -156.57 -159.22c-16.17,-16.44 -36.64,6.36 -21.57,21.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollRight);
export default __webpack_public_path__ + "static/media/scroll_right.74231e3f2708564ead87b052a75aa501.svg";
export { ForwardRef as ReactComponent };